import { Finances } from './Finances';

export default Finances;
